module.exports = __webpack_public_path__ + "img/be37457b3d106a02398f0e306b7c7f8f.png";